import PropTypes from 'prop-types';
import { memo } from 'react';

const _PageBanner = ({
	paddingTop,
	paddingBottom,
	eyebrow,
	title,
	titleElement,
	subtitle,
	description,
}) => {
	const paddingTopMap = {
		Medium: 'page-banner--top--md',
		Small: 'page-banner--top--sm',
		None: '',
	};
	const paddingBottomMap = {
		Medium: 'page-banner--bottom--md',
		Small: 'page-banner--bottom--sm',
		None: '',
	};
	const titleTypographyMap = {
		H1: { el: 'h1', className: 'typography--h1' },
		H2: { el: 'h2', className: 'typography--h2' },
	};
	const titleTypography = titleTypographyMap[titleElement];
	const Title = titleTypography?.el || 'h1';

	return (
		<div
			className={`section page-banner ${paddingTopMap[paddingTop]} ${paddingBottomMap[paddingBottom]}`}
		>
			<div className="section__content">
				{eyebrow && <p className="typography typography--overline">{eyebrow}</p>}
				<Title
					className={`typography ${titleTypography?.className} typography--secondary page-banner__title`}
				>
					{title}
				</Title>
				{subtitle && (
					<h2 className={'typography typography--h5 page-banner__subtitle'}>
						{subtitle}
					</h2>
				)}
				<p className="typography typography--subtle-big">
					{description?.description}
				</p>
			</div>
		</div>
	);
};

_PageBanner.propTypes = {
	paddingTop: PropTypes.oneOf(['Medium', 'Small', 'None']).isRequired,
	paddingBottom: PropTypes.oneOf(['Medium', 'Small', 'None']).isRequired,
	eyebrow: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	title: PropTypes.string.isRequired,
	titleElement: PropTypes.oneOf(['H1', 'H2']),
	subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	description: PropTypes.shape({
		description: PropTypes.string,
	}),
	className: PropTypes.string,
};

_PageBanner.defaultProps = {
	title: null,
	titleElement: 'H1',
	body: null,
	className: '',
	subtitleClassName: '',
};

const PageBanner = memo(_PageBanner);

export default PageBanner;
